/* __next_internal_client_entry_do_not_use__ default auto */ import dynamic from "next/dynamic";
import Loading from "./loading";
const Pdf = dynamic(()=>import("./component"), {
    loadableGenerated: {
        webpack: ()=>[
                require.resolveWeak("./component")
            ]
    },
    ssr: false,
    loading: Loading
});
export default Pdf;
